import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { TableComponent } from '../table/table.component';
import { debounce } from 'lodash';

@Component({
  selector: 'app-winlose',
  templateUrl: './winlose.component.html',
  styleUrls: ['./winlose.component.scss']
})
export class WinloseComponent implements AfterViewInit {

  public type;
  public searchDebounced = debounce(this.updateRemarkSearch, 1000);

  range = new UntypedFormGroup({
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  public today = new Date();
  public searchRemark: any;
  public searchGame: any;
  public searchCode: any;
  public searchUsername: any;

  @ViewChild("history", { static: false }) wl: TableComponent;

  constructor(private route: ActivatedRoute, private cdr: ChangeDetectorRef) {

  }

  ngAfterViewInit() {
    const type: Observable<string> = this.route.params.pipe(map(p => p['type']));
    type.subscribe(val => {
      if (!this.type || this.type != val) {
        this.type = val;
        var oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

        this.range.setValue({
          start: oneWeekAgo,
          end: this.today,
        });
      }
      this.initTable();
    })
  }

  initTable() {

    switch (this.type) {

      case 'game':
        const game =
        {
          post: {
            url: "/admin/winlose",
            data: {
              type: this.type,
              range: this.range.value,
              search: {
                game: this.searchGame,
                code: this.searchCode,
                username: this.searchUsername
              }
            }
          },
          disabled_pagenat: false,
          show_sum: true,
          fields: [
            { label: 'No', type: 'index' },
            { label: 'Admin', type: 'string', key: 'admin_name' },
            { label: 'Type', type: 'string', key: 'type' },
            { label: 'Game', type: 'string', key: 'game_name' },
            { label: 'Game ID', type: 'string', key: 'player_username' },
            { label: 'Player Code', type: 'string', key: 'player_code' },
            { label: 'Player Name', type: 'string', key: 'player_name' },
            { label: 'Adj Debit/In', type: 'price', key: 'debit_adjustment', sum: true, border_left: true, border_right: true },
            { label: 'Adj Credit/Out', type: 'price', key: 'credit_adjustment', sum: true, border_left: true, border_right: true },
            { label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true },
            { label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true },
            { label: 'Balance', type: 'price', key: 'balance', sum: true, border_left: true, border_right: true, primary_bg: true },
            { label: 'Bonus', type: 'price', key: 'bonus', sum: true, border_left: true, border_right: true },
            { label: 'Update', type: 'date', key: 'timestamp' },
          ]
        }
        this.wl.init(game);
        break;

      case 'bank':
        const bank =
        {
          post: { url: "/admin/winlose", data: { type: this.type, range: this.range.value } },
          disabled_pagenat: false,
          show_sum: true,
          fields: [
            { label: 'No', type: 'index' },
            { label: 'Admin', type: 'string', key: 'admin_name' },
            { label: 'Type', type: 'string', key: 'type' },
            { label: 'Bank', type: 'string', key: 'bank_name' },
            { label: 'Player Code', type: 'string', key: 'player_code' },
            { label: 'Player Name', type: 'string', key: 'player_name' },
            { label: 'Adj Debit', type: 'price', key: 'debit_adjustment', sum: true, border_left: true, border_right: true },
            { label: 'Adj Credit', type: 'price', key: 'credit_adjustment', sum: true, border_left: true, border_right: true },
            { label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true },
            { label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true, primary_bg: true },
            { label: 'Balance', type: 'price', key: 'balance', sum: true, border_left: true, border_right: true },
            { label: 'Tips', type: 'price', key: 'tips', sum: true },
            { label: 'Update', type: 'date', key: 'date' },
          ]
        }
        this.wl.init(bank);
        break;

      case 'player':
        const player =
        {
          post: {
            url: "/admin/winlose",
            data: {
              type: this.type,
              range: this.range.value,
              search: {
                remark: this.searchRemark,
                game: this.searchGame,
                code: this.searchCode,
                username: this.searchUsername
              }
            }
          },
          disabled_pagenat: false,
          show_sum: true,
          fields: [
            { label: 'No', type: 'index' },
            { label: 'Admin', type: 'string', key: 'admin_name' },
            { label: 'Type', type: 'string', key: 'type' },
            { label: 'Game', type: 'string', key: 'game_name' },
            { label: 'Game ID', type: 'string', key: 'player_username' },
            { label: 'Player Code', type: 'string', key: 'player_code' },
            { label: 'Player Name', type: 'string', key: 'player_name' },
            { label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true },
            { label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true },
            { label: 'Balance', type: 'price', key: 'balance', sum: true, border_left: true, border_right: true, primary_bg: true },
            { label: 'Bonus', type: 'price', key: 'bonus', sum: true, border_left: true, border_right: true },
            { label: 'Profit', type: 'price', key: 'game_profit', sum: true, border_left: true, border_right: true },
            { label: 'Update', type: 'date', key: 'create_on' },
            { label: 'Remark', type: 'string', key: 'player_remark' },
          ]
        }
        this.wl.init(player);
        break;

      case 'player-summary':
        const playerSummary =
        {
          post: { url: "/admin/winlose", data: { type: this.type, range: this.range.value, search: this.searchRemark } },
          disabled_pagenat: false,
          show_sum: true,
          fields: [
            { label: 'No', type: 'index' },
            { label: 'Player Code', type: 'string', key: 'player_code' },
            { label: 'Player Name', type: 'string', key: 'player_name' },
            { label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true },
            { label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true },
            { label: 'Bonus', type: 'price', key: 'bonus', sum: true, border_left: true, border_right: true },
            { label: 'Profit', type: 'price', key: 'game_profit', sum: true, border_left: true, border_right: true },
            { label: 'Remark', type: 'string', key: 'player_remark' },
          ]
        }
        this.wl.init(playerSummary);
        break;
    }

    this.cdr.detectChanges();
  }

  inputchange() {
    const val = this.range.value;

    if (val.start && val.end) {
      this.initTable();
    }
  }

  updateRemarkSearch() {
    this.initTable()
  }
}
